import { FILTER_TYPES, PAGE_SIZE_FILTER } from 'constants/filterType';

export const ORDER_FILTER_OPTIONS = [
  {
    field: 'order_status',
    label: 'Order Status',
    type: FILTER_TYPES.MULTI_SELECT,
    options: [
      { value: 'processing', label: 'Processing' },
      { value: 'created', label: 'Created' },
      { value: 'completed', label: 'Completed' },
      { value: 'cancelled', label: 'Cancelled' },
      { value: 'unfulfillable', label: 'Unfulfillable' },
    ],
  },
  {
    field: 'payment_type',
    label: 'Payment Type',
    type: FILTER_TYPES.SELECT,
    options: [
      { value: '', label: 'All' },
      { value: 'prepaid', label: 'Prepaid' },
      { value: 'cod', label: 'COD' },
    ],
  },
  {
    field: 'product_title__iconatins',
    label: 'Channel Product Name',
    type: FILTER_TYPES.TEXT,
  },
  {
    field: 'channel_order_created_after',
    label: 'Channel Order Created After',
    type: FILTER_TYPES.DATE,
  },
  {
    field: 'channel_order_created_before',
    label: 'Channel Order Created Before',
    type: FILTER_TYPES.DATE,
  },
  {
    field: 'created_after',
    label: 'WMS Order Created After',
    type: FILTER_TYPES.DATE,
  },
  {
    field: 'created_before',
    label: 'WMS Order Created Before',
    type: FILTER_TYPES.DATE,
  },
  { ...PAGE_SIZE_FILTER },
];
